export default "__VITE_ASSET__8f9ab29e__"